import { render, staticRenderFns } from "./CustomerSettingsTab.vue?vue&type=template&id=6fa70bbd&scoped=true&"
import script from "./CustomerSettingsTab.vue?vue&type=script&lang=js&"
export * from "./CustomerSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa70bbd",
  null
  
)

export default component.exports